<section class="profile-receipts">

    <app-profile-section-header title="Mis recibos" subtitle="Todos mis recibos">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2"/>
            <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </app-profile-section-header>

    <div class="pr-filters" [class.pr-filters--open]="filtersOpen">
        <button type="button" class="pr-filters-head" (click)="toggleFilters()" [attr.aria-expanded]="filtersOpen">
            <span>Filtros</span>
            <svg class="pr-filters-toggle" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path *ngIf="filtersOpen" d="M5 12h14" stroke-linecap="round"/>
                <path *ngIf="!filtersOpen" d="M12 5v14M5 12h14" stroke-linecap="round"/>
            </svg>
        </button>

        <div *ngIf="filtersOpen" class="pr-filters-body">
            <div class="pr-filters-row">
                <div class="pr-select">
                    <select [(ngModel)]="filters.product">
                        <option value="">Todos los seguros</option>
                        <option *ngFor="let o of productList" [value]="o.id">{{ o.itemName }}</option>
                    </select>
                    <svg class="pr-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="pr-select">
                    <select [(ngModel)]="filters.statusType">
                        <option value="">Todos los estados</option>
                        <option *ngFor="let o of statusTypeList" [value]="o.id">{{ o.itemName }}</option>
                    </select>
                    <svg class="pr-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="pr-select">
                    <input type="text" [(ngModel)]="filters.policyNumber" placeholder="Nº de póliza">
                    <svg class="pr-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <circle cx="11" cy="11" r="7"/>
                        <path d="m20 20-3.5-3.5" stroke-linecap="round"/>
                    </svg>
                </div>
                <div class="pr-select">
                    <input type="text" [(ngModel)]="filters.policyCollective" placeholder="Nº de colectivo">
                    <svg class="pr-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <circle cx="11" cy="11" r="7"/>
                        <path d="m20 20-3.5-3.5" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
            <div class="pr-filters-row pr-filters-row--bottom">
                <div class="pr-date">
                    <label>Fecha (desde)</label>
                    <div class="pr-date-input">
                        <input type="text" [(ngModel)]="filters.startDate" placeholder="dd/mm/yyyy">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                            <rect x="3" y="5" width="18" height="16" rx="2"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                            <line x1="8" y1="3" x2="8" y2="7"/>
                            <line x1="16" y1="3" x2="16" y2="7"/>
                        </svg>
                    </div>
                </div>
                <div class="pr-date">
                    <label>Fecha (hasta)</label>
                    <div class="pr-date-input">
                        <input type="text" [(ngModel)]="filters.endDate" placeholder="dd/mm/yyyy">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                            <rect x="3" y="5" width="18" height="16" rx="2"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                            <line x1="8" y1="3" x2="8" y2="7"/>
                            <line x1="16" y1="3" x2="16" y2="7"/>
                        </svg>
                    </div>
                </div>
                <button type="button" class="pr-apply" (click)="applyFilters()" [disabled]="loading">
                    {{ loading ? 'Cargando...' : 'Aplicar filtros' }}
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="response === undefined" class="pr-loading">
        <p>Cargando<span>.</span><span>.</span><span>.</span></p>
    </div>

    <div class="pr-list" *ngIf="response?.content?.length > 0">
        <article class="pr-card" *ngFor="let item of response.content">
            <div class="pr-card-icon">
                <svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                    <rect x="4" y="6" width="20" height="16" rx="2"/>
                    <path d="M4 8l10 6 10-6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div class="pr-card-col">
                <div class="pr-field">
                    <span class="pr-label">Nº de recibo</span>
                    <strong class="pr-value">{{ item.receiptNumber }}</strong>
                </div>
                <div class="pr-field" *ngIf="!item.docCobroNumber">
                    <span class="pr-label">Nº de póliza/contrato</span>
                    <strong class="pr-value pr-value--medium">
                        {{ item.policyNumber }}
                        <span *ngIf="item.policyCollective" class="pr-collective">(Colectivo {{ item.policyCollective }})</span>
                    </strong>
                </div>
                <div class="pr-field" *ngIf="item.docCobroNumber">
                    <span class="pr-label">Doc. Cobro</span>
                    <strong class="pr-value pr-value--medium">
                        {{ item.docCobroNumber }}
                        <span *ngIf="item.policyCollective" class="pr-collective">(Colectivo {{ item.policyCollective }})</span>
                    </strong>
                </div>
                <div class="pr-field">
                    <span class="pr-label">Vigencia</span>
                    <span class="pr-text">{{ item.receiptStartDate | date:'dd/MM/yyyy' }} - {{ item.receiptEndDate | date:'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <div class="pr-card-col">
                <div class="pr-field">
                    <span class="pr-label pr-label--icon">
                        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <rect x="1.5" y="2" width="9" height="7" rx="1"/>
                            <path d="M3 5h6M3 7h4" stroke-linecap="round"/>
                        </svg>
                        Producto
                    </span>
                    <strong class="pr-value">{{ item.policyProduct }}</strong>
                </div>
                <div class="pr-field">
                    <span class="pr-label">Tipo de cobro</span>
                    <span class="pr-text">{{ item.receiptPaymentMethod }}</span>
                </div>
                <div class="pr-field">
                    <span class="pr-label">Periocidad</span>
                    <span class="pr-text">{{ item.policyPeriodicity }}</span>
                </div>
                <div class="pr-field" *ngIf="item.receiptType === 'E' && !item.docCobroNumber">
                    <span class="pr-badge pr-badge--info">Operación de Extorno</span>
                </div>
                <div class="pr-field" *ngIf="item.docCobroNumber">
                    <span class="pr-badge pr-badge--info">Documento de Cobro</span>
                </div>
            </div>

            <div class="pr-card-side">
                <div class="pr-amount">
                    <span class="pr-label pr-label--right">Importe</span>
                    <strong class="pr-amount-value" [class.pr-amount-value--danger]="isPending(item)">
                        {{ item.receiptAmount | currency:'EUR' }}
                    </strong>
                    <span class="pr-badge" [class.pr-badge--danger]="isPending(item)">
                        {{ item.receiptStatus }}
                    </span>
                </div>
                <button *ngIf="!isPending(item)" type="button" class="pr-action" (click)="download(item)">
                    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
                        <path d="M10 3v10m0 0l-4-4m4 4l4-4M3 17h14" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Descargar
                </button>
                <app-actions-dropdown
                    *ngIf="isPending(item) && item.receiptType !== 'E'"
                    label="PAGAR"
                    [items]="item.payActions">
                </app-actions-dropdown>
            </div>
        </article>
    </div>

    <div class="pr-no-results" *ngIf="response?.content?.length === 0">
        No hay recibos disponibles.
    </div>

    <nav class="pr-pagination" aria-label="Paginación" *ngIf="response?.content?.length > 0 && response?.totalPages > 1">
        <a class="pr-pag-link" [class.pr-pag-link--disabled]="response.first || loading" (click)="prev()">Anterior</a>
        <ul class="pr-pag-numbers">
            <li *ngFor="let p of getPages()"
                [class.active]="p !== null && p === currentPage"
                [class.pr-pag-ellipsis]="p === null"
                (click)="p !== null && goToPage(p)">
                {{ p !== null ? p : '...' }}
            </li>
        </ul>
        <a class="pr-pag-link" [class.pr-pag-link--disabled]="response.last || loading" (click)="next()">Siguiente</a>
    </nav>

</section>
